import { ActionType } from "types/JWT";

export const hasAction = (element: ActionType) => (action: ActionType) =>
  element === action;
